// 단일 olive-jp 기준. 멀티테넌시(테넌트 스위칭/화이트라벨) 롤백됨.
// 시그니처(getBrand/getFileDownloadUrl)는 유지해 기존 호출부 변경을 최소화한다.

interface TenantBrand {
    /** 로그인 대문 문구 */
    loginTitle: string
    /** 좌상단(사이드바) 로고 이미지 경로. 없으면 logoText 표시 */
    logoImg?: string
    /** 로고 이미지가 없을 때 좌상단에 표시할 텍스트 */
    logoText?: string
}

const OLIVE_BRAND: TenantBrand = { loginTitle: 'OLIVE JP DMS', logoText: 'Olive-JP' }

export const getBrand = (): TenantBrand => OLIVE_BRAND

// S3 다운로드 베이스 URL (단일 버킷).
export const getFileDownloadUrl = (): string => process.env.REACT_APP_FILE_DOWNLOAD_URL || ''
